<template>
	<div class="gjuha-settings-wrapper">
		<v-radio-group
			class="radio-btn-wrapper"
			row
			v-model="type_language"
			:mandatory="false"
		>
			<v-radio
				class="radio-btn-item"
				:class="{ 'border-checked': type_language == 1 }"
				:label="getStateWithParam('albanian_label')"
				:value="1"
			></v-radio>
			<v-radio
				class="radio-btn-item"
				:class="{ 'border-checked': type_language == 2 }"
				:label="getStateWithParam('english_label')"
				:value="2"
			></v-radio>
		</v-radio-group>
	</div>
</template>

<script>
export default {
	name: 'LanguageSettings',
	data() {
		return {
		};
	},
	computed: {
		type_language: {
			get(){
				return this.$store.state.type_language
			},
			set(value){
				this.$store.commit('setNewLanguageType', parseInt(value))
			}
		}
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss" scoped>
.gjuha-settings-wrapper {
	margin-top: 10px;
	margin-bottom: 10px;
	.radio-btn-wrapper {
		margin: 0;
		padding: 0;
	}
}
.v-radio {
	flex-direction: column-reverse;
}
.v-input--radio-group__input {
	display: flex;
	.radio-btn-item {
		flex: 1;
		border-radius: 10px;
		background-color: white;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
		border: 2px solid white;
		height: 50px;
		transition: border 0.2s ease-in-out;
		&:first-child {
			margin-right: 10px !important;
			margin: 0;
		}
		&:last-child {
			margin: 0;
			margin-left: 10px !important;
		}
		.v-input--selection-controls__input {
			display: none !important;
		}
	}
}
</style>
